import axios from 'axios'
import { message as Message } from 'antd';
import API_CONFIG from '@/config/apiConfig';

const message = Message
message.config({
    duration: 2,
    maxCount: 3,
})
const isObject = v => {
    return Object.prototype.toString.call(v) === '[object Object]'
}

// Create an axios instance with the correct baseURL
const apiClient = axios.create({
    baseURL: API_CONFIG.apiUrl,
    headers: {
        'token': localStorage.getItem('authToken') || '',
        'orgId': localStorage.getItem('authOrgId') || '',
        'X-Tenant-ID': localStorage.getItem('authOrgId') || ''
    }
});

apiClient.interceptors.response.use(response => {
    if (response.status !== 200) {
        return Promise.reject(response)
    }
    return response
}, (error) => {
    let status = error.response ? error.response.status : 500
    switch (status) {
        case 400:
            message.error(error.response.data.message || 'Sorry, the request parameters are incorrect. Please check and try again.')
            break
        case 401:
            message.destroy()
            // Clear auth data on token expiration
            localStorage.removeItem('authToken');
            localStorage.removeItem('authUserId');
            localStorage.removeItem('authUserName');
            localStorage.removeItem('authRoleList');
            localStorage.removeItem('authOrgId');
            message.error('Your session has expired. Please log in again.', function () {
                window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname)
            })
            break
        case 412:
            message.destroy()
            // Clear auth data on duplicate login
            localStorage.removeItem('authToken');
            localStorage.removeItem('authUserId');
            localStorage.removeItem('authUserName');
            localStorage.removeItem('authRoleList');
            localStorage.removeItem('authOrgId');
            message.error('This account has logged in elsewhere. Please log in again.', function () {
                window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname)
            })
            break
        case 403:
            message.destroy()
            message.error('Sorry, you do not have permission to perform this operation')
            break
        case 404:
            message.error('Sorry, the requested service does not exist')
            break
        case 422:
            message.error('The data you submitted is in the wrong format, please check again')
            break
        case 500:
            message.error(error.response.data.message || 'Internal server error')
            break
        default:
            message.destroy()
            message.error(error.response.data.message || ('Internal server error (' + status + ')'))
    }
    return Promise.reject(error)
})

const methods = ['post', 'get', 'delete', 'put', 'patch']
const ajax = {}
methods.forEach((method) => {
    ajax[method] = function (url, pms = {}, ops = {}) {
        ops = isObject(ops) ? ops : {}
        let request = (method === 'get' || method === 'delete') ? apiClient[method](url, { params: pms, ...ops }) : apiClient[method](url, pms, ops)
        return request.then(response => {
            let res = response.data
            let success = res.code === '0' || res.code === 'SUCCESS' || !res.message
            if (success) {
                return Promise.resolve(response.data)
            } else {
                message.error(res.message || 'The system is busy, please try again later')
                return Promise.reject(res)
            }
        }, error => {
            return Promise.reject(error)
        })
    }
})

const getQueryString = function (name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r !== null) return unescape(r[2]);
    return null;
}

const dateFormat = (dt, fmt = 'yyyy-MM-dd hh:mm:ss') => {
    let newDate = dt
    if (!dt) {
        return ''
    }
    // debugger
    if (typeof dt === 'string') {
        // dt = dt.replace(/-/g, '/') // IOS上只支持yyyy/MM/dd这种标准格式
        dt = /^\d+$/.test(dt) ? parseInt(dt) : /.\+./.test(dt) ? new Date(dt) : dt.replace(/-/g, '/') // 传入的日期可能是个纯数字组成的字符串，如"1511107200000"
    }
    if (dt instanceof Date === false) {
        dt = new Date(dt)
    }
    if (!dt.getTime()) {
        return newDate
    }

    let o = {
        'M+': dt.getMonth() + 1, // Month
        'd+': dt.getDate(), // Day
        'h+': dt.getHours(), // Hour
        'm+': dt.getMinutes(), // Minute
        's+': dt.getSeconds(), // Second
        'q+': Math.floor((dt.getMonth() + 3) / 3), // Quarter
        S: dt.getMilliseconds() // Millisecond
    }

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
            RegExp.$1,
            (dt.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
    }

    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1
                    ? o[k]
                    : ('00' + o[k]).substr(('' + o[k]).length)
            )
        }
    }

    return fmt
}

const arrayToTree = function (items) {
    const result = [];
    const itemMap = {};

    for (const item of items) {
        itemMap[item.id] = { ...item, children: [] }
    }

    for (const item of items) {
        const id = item.id;
        const pid = item.parentId;

        const treeItem = itemMap[id];

        if (pid === undefined) {
            result.push(treeItem);
        } else {
            if (!itemMap[pid]) {
                itemMap[pid] = {
                    children: [],
                }
            }
            itemMap[pid].children.push(treeItem);
        }
    }
    return result;
}

const transformData = function (data) {
    return data.map(item => {
        const children = item.children.length > 0 ? this.transformData(item.children) : undefined;
        return {
            title: item.name,
            value: item.id,
            key: item.id,
            children
        };
    });
}

// export const ajax = ajax
export {
    isObject,
    ajax,
    getQueryString,
    message,
    dateFormat,
    arrayToTree,
    transformData,
}